import { axios, Response } from '..'

export interface CreateTaskCommentRequest {
  taskCommentId: string
  content: string
  taskId: string
}

export const createTaskComment = (
  request: CreateTaskCommentRequest
): Response<void> => {
  return axios.post(`/v1/tasks/comments/`, request)
}
